import { createContext } from "react";

// pageName: current page name (e.g. "Sales Revenue").
// enabled: whether filter tracking is active in this subtree (set by the page/feature that opts in).
const TrackingContext = createContext({ pageName: null, enabled: false });

export { TrackingContext };
